module.exports = __webpack_public_path__ + "img/welfare-blackfriday.49b0a29a.png";